import { render, staticRenderFns } from "./board.vue?vue&type=template&id=9ef49f3a&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"
import style0 from "./board.vue?vue&type=style&index=0&id=9ef49f3a&prod&lang=css"
import style1 from "./board.vue?vue&type=style&index=1&id=9ef49f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef49f3a",
  null
  
)

export default component.exports